<dx-box class="registration-container">
  <dxi-item [ratio]="1">
    <div *dxTemplate>
      <app-signup
        *ngIf="showSignup"
        [userInfo]="userInfo"
        (onRegistrationUpdate)="onRegistrationUpdate($event)"
      ></app-signup>
      <app-signup-account-name
        *ngIf="showAccountPortal"
        [userInfo]="userInfo"
        [registrationEditor]="registrationEditor"
        (onPortalAccountUpdate)="onPortalAccountUpdate($event)"
        (onPreviousClick)="onPortalAccountPreviousClick()"
      ></app-signup-account-name>
      <app-signup-email-options
        *ngIf="showEmailCommunication"
        [userInfo]="userInfo"
        [registrationEditor]="registrationEditor"
        (onEmailCommunicationUpdate)="onEmailCommunicationUpdate($event)"
        (onPreviousClick)="onEmailCommunicationPreviousClick()"
      ></app-signup-email-options>
      <app-signup-text-options
        *ngIf="showTextCommunication"
        [userInfo]="userInfo"
        [registrationEditor]="registrationEditor"
        (onPreviousClick)="onTextCommunicationPreviousClick()"
      ></app-signup-text-options>
    </div>
  </dxi-item>
</dx-box>
